import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import { carIcon, DEFAULT_MAP_CENTER } from './mapIcons';

function FitVehicleBounds({ vehicles }) {
  const map = useMap();
  useEffect(() => {
    if (vehicles.length === 0) return;
    if (vehicles.length === 1) {
      map.setView([vehicles[0].lat, vehicles[0].lng], 13);
      return;
    }
    map.fitBounds(vehicles.map((v) => [v.lat, v.lng]), { padding: [50, 50] });
  }, [vehicles, map]);
  return null;
}

export default function LiveMap({ vehicles }) {
  return (
    <MapContainer
      center={DEFAULT_MAP_CENTER}
      zoom={13}
      className="w-full h-64 rounded-2xl z-0"
      scrollWheelZoom={false}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {vehicles.map((v) => (
        <Marker key={v.driverId} position={[v.lat, v.lng]} icon={carIcon}>
          <Popup>{[v.model, v.color].filter(Boolean).join(' · ') || v.driverName}</Popup>
        </Marker>
      ))}
      <FitVehicleBounds vehicles={vehicles} />
    </MapContainer>
  );
}
